import { Button } from "antd";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import {
  useCustomAttendanceReportReqOnlyTimeMutation,
  useGenerateCustomAttendanceReportMutation,
} from "../../../features/report/reportApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import { CustomModalProps } from "../../../types";
import ReportRequestModal from "../../Report/ReportRequestModal";
import CustomModal from "../../ui/CustomModal";

type ModalType = "REPORT_REQUEST_DETAILS" | "REPORT_REQUEST_OVERTIME";

type Props<T> = {
  filter?: T;
} & CustomModalProps;

export default function CustomReportRequestButtonModal<T>({
  filter,
  ...rest
}: Props<T>) {
  const { open, handleClose, handleOpen } = useModal<boolean, ModalType>();
  const [
    generateCustomAttendanceReport,
    {
      isLoading: isGenerateLoading,
      isError: isGenerateError,
      error: generateError,
      isSuccess: isGenerateSuccess,
    },
  ] = useGenerateCustomAttendanceReportMutation();
  const [
    customAttendanceReportReqOnlyTime,
    {
      isLoading: isSummaryLoading,
      isError: isSummaryError,
      error: summaryError,
      isSuccess: isSummarySuccess,
    },
  ] = useCustomAttendanceReportReqOnlyTimeMutation();
  useError(isGenerateError, generateError, "Generate request report fail");
  useError(
    isSummaryError,
    summaryError,
    "Overtime summary report request fail"
  );

  const handleDownloadRequest = (
    dates: {
      start_date: string;
      end_date: string;
    },
    selected?: string[]
  ) => {
    const safeSelected = selected?.filter(
      (col) => col !== "line_manager_name" && col !== "line_manager_email"
    );

    console.log(filter);
    switch (open?.type) {
      case "REPORT_REQUEST_DETAILS":
        generateCustomAttendanceReport({
          body: {
            name: "Custom Attendance",
            column_list: safeSelected,
          },
          params: {
            status: "active",
            ...filter,
            ...dates,
            skip: undefined,
            limit: undefined,
          },
        });
        break;
      case "REPORT_REQUEST_OVERTIME":
        customAttendanceReportReqOnlyTime({
          body: {
            name: "Custom attendance only attendance time",
          },
          params: {
            ...filter,
            ...dates,
            status: "active",
            skip: undefined,
            limit: undefined,
          },
        });
        break;
    }
  };

  return (
    <CustomModal
      title="Report Request"
      footer={null}
      width={550}
      // closeIcon={null}
      {...rest}
    >
      <ReportRequestModal
        handleClose={handleClose}
        open={open?.open}
        handleSubmit={handleDownloadRequest}
        isLoading={isGenerateLoading || isSummaryLoading}
        isSuccess={isGenerateSuccess || isSummarySuccess}
        columnList={open?.data ? columnList : undefined}
      />

      <div className="grid grid-cols-2 gap-4">
        <Button
          onClick={() =>
            handleOpen({ type: "REPORT_REQUEST_DETAILS", data: true })
          }
          className="download-button w-full"
          icon={<DownloadIcon />}
        >
          Custom Attendance Full Details
        </Button>
        <Button
          onClick={() => handleOpen({ type: "REPORT_REQUEST_OVERTIME" })}
          className="download-button w-full"
          icon={<DownloadIcon />}
        >
          Custom Attendance
        </Button>
      </div>
    </CustomModal>
  );
}

const columnList = [
  "employee_id",
  "employee_name",
  "employee_email",
  "employee_department",
  "employee_designation",
  "employee_address",
  "total_days",
  "working_days",
  "weekend",
  "holiday",
  "present",
  "on_leave",
  "absent",
  "on_time",
  "late",
  "left_timely",
  "left_early",
  "total_hours",
  "overtime",
  "total_remote_checkin",
  "total_office_checkin",
  "total_remote_checkout",
  "total_office_checkout",
  "total_checkout_missing",
  "joining_prorated",
  "leave_days",
  "late_days",
  "absent_days",
  "weekend_holiday_attendances",
  "work_from_home",
];
